import { Identificable } from 'shared/types/commonView';
import { LabelledUser } from '../../user/mapping/toView';
import { AccessLevelModel } from '../mapping/accessLevel/model/types';
import { UserAccess } from '../mapping/accessLevel/toOnView/types';
import { isAtLeastManager } from './isAtLeastManager';
import { isAtLeastStandard } from './isAtLeastStandard';

export function canBeGrantedEditAccess(
  users: LabelledUser[],
  value: Identificable | null | undefined,
  userAccesses: UserAccess[]
): boolean {
  if (!value) {
    return false;
  }
  const user = users.find((user) => user._id === value._id);
  if (user && isAtLeastManager(user.role)) {
    return false;
  } else if (user && isAtLeastStandard(user.role)) {
    const userAccess = userAccesses.find(
      (access) => access.accessingUser === value._id
    );
    return userAccess?.accessLevel !== AccessLevelModel.EDIT;
  } else {
    return false;
  }
}
